@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.modalOverlay {
  background: rgba(15, 23, 42, 0.75);
  backdrop-filter: blur(4px);
  animation: fadeIn 0.2s ease-out;
}

.modalContent {
  animation: slideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

